import axios from '../../helpers/axios-setup';

export const getInteroperabilityTemplates = () => axios.get(`/interoperability-templates`);
